import { QueryClientProvider } from '@tanstack/react-query';
import type { ReactNode } from 'react';
import { appQueryClient } from './queryClient.js';

export interface QueryProviderProps {
  readonly children: ReactNode;
}

export function QueryProvider({ children }: QueryProviderProps): JSX.Element {
  return <QueryClientProvider client={appQueryClient}>{children}</QueryClientProvider>;
}
